import { FC } from 'react';
import style from './index.module.css';

export const ShippingAddressDetail: FC<{ 
  title: string,
  value: string | undefined,
}> = ({ title, value }) => {

  return (
    <dl className={style.dl}>
      <dt className={style.dt}>{title}</dt>
      <dd className={style.dd}>{value ? value : '読み込み中...'}</dd>
    </dl>
  );
}